// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersModelsClsInboundDocument {
    'documentID'?: string | null;
    'documentName'?: string | null;
    'documentCategory'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersModelsClsInboundDocument>> = [
        {
            "name":     "documentID",
            "baseName": "documentID",
            "type":     "string"
        },
        {
            "name":     "documentName",
            "baseName": "documentName",
            "type":     "string"
        },
        {
            "name":     "documentCategory",
            "baseName": "documentCategory",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersModelsClsInboundDocument.attributeTypeMap;
    }
}
